import { Cpg, SubmissionGroupLocationFragment } from '@occc/graphql';

export const isLocationSelectableForCpg = (
  location: SubmissionGroupLocationFragment,
  cpg: Cpg,
): boolean => {
  if (cpg === Cpg.Altria) {
    return Boolean(location.altriaMan) || Boolean(location.altriaRcn);
  }
  return Boolean(location.rjrAccountNumber);
};
